<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			<form>
				<div class="formgroup">
					<div class="flex justify-content-center" *ngIf="loading">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-auto mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid pt-3 px-3" *ngIf="pagamentoDespesa">
						<div class="col-12 card-simple mb-5">
							<div class="p-fluid p-formgrid grid">

								<div class="col-12 md:col-6 xl:col-3">
									<label class="label-superior">Especificação</label>
									<label class="label-inferior">{{ pagamentoDespesa.planoContaEmpresa?.descricao }}</label>
								</div>
								
		
								<div class="col-12 md:col-6 xl:col-3">
									<label class="label-superior">Identificação</label>
									<label class="label-inferior">{{ pagamentoDespesa.identificacao }}</label>
								</div>
								
								<div class="col-12 md:col-6 xl:col-3" >
									<label class="label-superior">Vencimento</label>
									<label class="label-inferior">{{ pagamentoDespesa.dataVencimento | date:'dd/MM/yyyy' }}</label>
								</div>
								<div class="col-12 md:col-6 xl:col-3">
									<label class="label-superior">Competência</label>
									<label class="label-inferior">{{ pagamentoDespesa.competencia | date:'MM/yyyy' }}</label>
								</div>
								<div class="col-12 md:col-6 xl:col-3">
									<label class="label-superior">Valor da Despesa</label>
									<label class="label-inferior">{{ pagamentoDespesa.valorFluxo | currency: 'BRL':'symbol':'1.2-2' }}</label>
								</div>
								<div class="col-12 md:col-6 xl:col-3" *ngIf="pagamentoDespesa.status === 1">
									<label class="label-superior">Tipo de Pagamento</label>
									<label class="label-inferior" id="descricao">{{ pagamentoDespesa.tipoPagamento?.descricao }}</label>
								</div>
		
								<div class="col-12 md:col-6 xl:col-3" *ngIf="pagamentoDespesa.status === 1">
									<label class="label-superior">Data do Pagamento</label>
									<label class="label-inferior">{{ pagamentoDespesa.dataFluxo | date:'dd/MM/yyyy' }}</label>
								</div>
								<div class="col-12 md:col-6 xl:col-3" *ngIf="pagamentoDespesa.status === 2">
									<label class="label-superior">Data Ag. Pagamento</label>
									<label class="label-inferior">{{ pagamentoDespesa.dataFluxo | date:'dd/MM/yyyy' }}</label>
								</div>
		
								<div class="col-12 md:col-6 xl:col-3">
									<label class="label-superior">Status</label>
									<div class="label-inferior">
										<label class="product-badge status-outofstock" id="status" *ngIf="pagamentoDespesa.status === 0">A PAGAR</label>
										<label class="product-badge status-instock" id="status" *ngIf="pagamentoDespesa.status === 1">PAGO</label>
										<label class="customer-badge status-renewal" id="status" *ngIf="pagamentoDespesa.status === 2">AGENDADO</label>
										<label class="product-badge status-lowstock" id="status" *ngIf="pagamentoDespesa.status === 3">ESTORNADO</label>
		
									</div>
								</div>
							</div>
						</div>


					</div>

					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/pagamento-despesa"></button>
						</div>
					</div>

				</div>
			</form>
		</div>
	</div>
</div>